import React from 'react';

function PlayIcon() {
  return (
    <svg
      width="88px"
      height="88px"
      viewBox="0 0 88 88"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <circle
          fillOpacity="0.14"
          fill="#FFFFFF"
          stroke="#FFFFFF"
          strokeWidth="3"
          cx="44"
          cy="44"
          r="41.5"
        />
        <path
          d="M37.4298176,33.3427283 C37.8347081,33.1066004 38.3408213,33.1066004 38.7794526,33.3764608 L54.6042607,42.8553071 C55.0088138,43.091435 55.2449999,43.5299581 55.2449999,44.0022138 C55.2449999,44.4744695 55.0088138,44.9129926 54.6042607,45.1491204 L38.8131935,54.6279667 C38.5770074,54.7628969 38.3408213,54.830362 38.1046351,54.830362 C37.868449,54.830362 37.6322629,54.7966295 37.4298176,54.6616993 C37.0249271,54.4255714 36.7550001,53.9870483 36.7550001,53.4810601 L36.7550001,34.5233675 C36.7550001,34.0173793 36.9911862,33.5788561 37.4298176,33.3427283 Z"
          fill="#FFFFFF"
        />
      </g>
    </svg>
  );
}

export default PlayIcon;
